import React from 'react';
import { cn } from '@/utils/cn';
import type { MetaDevicePlatform } from '@/services/api/metaAds';

interface DevicesSectionProps {
  devicePlatforms: MetaDevicePlatform[];
  onChange: (platforms: MetaDevicePlatform[]) => void;
}

/**
 * Device platform filter. Empty = all devices (Meta picks based on
 * placements). The wizard exposes mobile / desktop toggles for the
 * common "mobile-only campaign" case.
 */
export const DevicesSection: React.FC<DevicesSectionProps> = ({
  devicePlatforms,
  onChange,
}) => {
  const toggle = (p: MetaDevicePlatform) => {
    if (devicePlatforms.includes(p)) {
      onChange(devicePlatforms.filter((x) => x !== p));
    } else {
      onChange([...devicePlatforms, p]);
    }
  };

  return (
    <div className="space-y-3">
      <p className="text-sm text-gray-600">
        Empty = all devices. Pick to restrict to mobile or desktop only.
      </p>
      <div className="flex gap-2">
        {(['mobile', 'desktop'] as const).map((p) => {
          const selected = devicePlatforms.includes(p);
          return (
            <button
              key={p}
              type="button"
              onClick={() => toggle(p)}
              aria-pressed={selected}
              className={cn(
                'flex-1 p-3 border-2 rounded-lg text-sm font-medium transition-all focus:outline-none focus:ring-2 focus:ring-blue-500',
                selected
                  ? 'border-blue-600 bg-blue-50 text-blue-900'
                  : 'border-gray-200 hover:bg-gray-50 bg-white text-gray-700',
              )}
            >
              {p === 'mobile' ? 'Mobile' : 'Desktop'}
            </button>
          );
        })}
      </div>
    </div>
  );
};
